module.exports = __webpack_public_path__ + "img/member-pic2.e2378013.png";